import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const PricingCard = ({
  title,
  price,
  description,
  features,
  isPrimary = false,
  ctaText = 'Get Started',
  ctaLink = '#'
}) => {
  return <div className={`rounded-xl p-1 ${isPrimary ? 'bg-gradient-to-br from-orange-400 to-orange-600' : 'bg-slate-800'}`} data-id="element-348">
      <div className={`h-full rounded-lg ${isPrimary ? 'bg-slate-900' : 'bg-slate-900 border border-slate-700'} p-6 md:p-8 flex flex-col`} data-id="element-349">
        <div className="mb-6" data-id="element-350">
          <h3 className="text-xl font-bold text-white mb-2" data-id="element-351">{title}</h3>
          <p className="text-slate-400 mb-4" data-id="element-352">{description}</p>
          <div className="flex items-baseline mb-2" data-id="element-353">
            <span className="text-3xl font-bold text-white" data-id="element-354">{price}</span>
            {price !== 'Free' && price !== 'Custom' && <span className="text-slate-400 ml-2" data-id="element-355">/month</span>}
          </div>
        </div>
        <ul className="space-y-3 mb-8 flex-grow" data-id="element-356">
          {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-357">
              {feature.included ? <CheckIcon size={20} className="text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-358" /> : <XIcon size={20} className="text-slate-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-359" />}
              <span className={feature.included ? 'text-slate-300' : 'text-slate-500'} data-id="element-360">
                {feature.text}
              </span>
            </li>)}
        </ul>
        <a href={ctaLink} target="_blank" rel="noopener noreferrer" className={`w-full py-3 rounded-md text-center font-medium transition-colors ${isPrimary ? 'bg-orange-500 text-white hover:bg-orange-600' : 'bg-slate-800 text-white hover:bg-slate-700 border border-slate-700'}`} data-id="element-361">
          {ctaText}
        </a>
      </div>
    </div>;
};
const Pricing = () => {
  const freePlanFeatures = [{
    text: 'Up to 2 forms',
    included: true
  }, {
    text: 'Up to 50 submissions/month',
    included: true
  }, {
    text: 'AI form builder',
    included: true
  }, {
    text: 'AI validations',
    included: true
  }, {
    text: 'Limited File extraction',
    included: true
  }, {
    text: 'Slack connection',
    included: true
  }];
  const proPlanFeatures = [{
    text: 'Up to 20 forms',
    included: true
  }, {
    text: 'Up to 1,500 submissions/month',
    included: true
  }, {
    text: 'AI form builder',
    included: true
  }, {
    text: 'Advanced Document extraction',
    included: true
  }, {
    text: 'Advanced AI validations',
    included: true
  }, {
    text: 'Slack connection',
    included: true
  }];
  const proPlanAddons = ['WhatsApp Connection', 'Email Connection', 'Enhanced Handwriting extraction'];
  const enterprisePlanFeatures = [{
    text: 'Unlimited forms',
    included: true
  }, {
    text: 'Unlimited submissions',
    included: true
  }, {
    text: 'All Pro features',
    included: true
  }, {
    text: 'Custom integrations',
    included: true
  }, {
    text: 'Priority support & SLA',
    included: true
  }, {
    text: 'Dedicated account manager',
    included: true
  }];
  return <section className="w-full bg-slate-950 py-20 border-t border-slate-800" id="pricing" data-id="element-362">
      <div className="container mx-auto px-4" data-id="element-363">
        <div className="text-center mb-12" data-id="element-364">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-365">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-366">
            Choose the plan that works for your team. Scale as you grow.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-367">
          <PricingCard title="Free Plan" price="Free" description="For adoption and exploration" features={freePlanFeatures} ctaText="Start Free" ctaLink="https://cal.com/fluidform/30min" data-id="element-368" />
          <div data-id="element-369">
            <PricingCard title="Pro Plan" price="$59" description="For teams & growing workflows" features={proPlanFeatures} isPrimary={true} ctaText="Go Pro" ctaLink="https://cal.com/fluidform/30min" data-id="element-370" />
            <div className="mt-4 bg-slate-900 border border-slate-700 rounded-lg p-4" data-id="element-371">
              <h4 className="text-sm font-semibold text-white mb-2" data-id="element-372">
                Optional Add-ons:
              </h4>
              <ul className="space-y-1" data-id="element-373">
                {proPlanAddons.map((addon, index) => <li key={index} className="text-sm text-slate-400" data-id="element-374">
                    • {addon}
                  </li>)}
              </ul>
            </div>
          </div>
          <PricingCard title="Enterprise" price="Custom" description="For large teams & custom needs" features={enterprisePlanFeatures} ctaText="Contact Sales" ctaLink="https://cal.com/fluidform/30min" data-id="element-375" />
        </div>
      </div>
    </section>;
};
export default Pricing;